'use client';
import React from 'react';

export default function PromoSection() {
  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 grid grid-cols-1 md:grid-cols-3 gap-3">
      {/* Flash Deal Banner */}
      <div className="col-span-1 md:col-span-2 bg-gradient-to-r from-green-600 to-green-800 rounded-2xl p-5 md:p-7 flex items-center justify-between overflow-hidden relative">
        <div className="absolute right-0 top-0 w-48 h-full bg-white/5 rounded-l-full" />
        <div>
          <p className="text-white/70 text-xs font-semibold uppercase tracking-widest mb-1">Flash Deal</p>
          <p className="text-white text-xl md:text-2xl font-extrabold leading-tight">
            Combo Offer<br />
            Up to <span className="text-yellow-300">55% OFF</span>
          </p>
          <p className="text-white/60 text-xs mt-1.5">Atta + Besan + Sugar + Oil</p>
          <button className="mt-3 bg-white text-green-800 text-xs font-extrabold px-4 py-2 rounded-lg hover:bg-yellow-300 transition-colors">
            Shop Now →
          </button>
        </div>
        <span className="text-6xl md:text-7xl select-none">🎁</span>
      </div>

      {/* Mini Promo Cards */}
      <div className="flex flex-col gap-3">
        <div className="bg-amber-50 border border-amber-200 rounded-2xl p-4 flex items-center gap-4">
          <span className="text-4xl">🥛</span>
          <div>
            <p className="font-bold text-gray-800 text-sm">Fresh Dairy</p>
            <p className="text-xs text-gray-500">From ₹29 onwards</p>
            <a href="#" className="text-xs text-[#0c831f] font-bold mt-1 inline-block">Shop →</a>
          </div>
        </div>
        <div className="bg-blue-50 border border-blue-200 rounded-2xl p-4 flex items-center gap-4">
          <span className="text-4xl">🧴</span>
          <div>
            <p className="font-bold text-gray-800 text-sm">Personal Care</p>
            <p className="text-xs text-gray-500">Min. 30% off on top brands</p>
            <a href="#" className="text-xs text-[#0c831f] font-bold mt-1 inline-block">Shop →</a>
          </div>
        </div>
      </div>
    </div>
  );
}
